import {
  CalendarOutlined,
  HourglassOutlined,
  VideoCameraOutlined,
  GlobalOutlined,
} from "@ant-design/icons";
import {Button, Image, Result, Space, Spin} from "antd";
import {useParams} from "react-router-dom";
import {useGetCustomerLiveClassBooking} from "../../../../react-query-hooks/booking";
import {
  getLiveClassJoinDisabledMessage,
  isLiveClassJoinButtonDisabled,
  resolveLiveClassJoinDisplayTimezone,
  resolveLiveClassJoinMeetingUrl,
} from "../../../../react-query-hooks/booking/live-class-join-normalizer";
import {PublicLayout} from "../../../../layouts/public";
import {StyledFlexContainer} from "../../../../styles/email-verification/email-verification";
import {
  StyledJoinCallBox,
  StyledJoinCallExtraInfo,
} from "../../../../styles/meetings/meetings";
import {LoadingSpinner} from "../../../../components/icons/icons";
import moment from "moment";
import momentTimeZone from "moment-timezone";

const LiveClassJoinMeetingPage = () => {
  const {reference} = useParams();

  const getCustomerLiveClassBookingQuery = useGetCustomerLiveClassBooking(
    {reference},
    {
      refetchInterval: (data) => {
        if (
          data?.videoPlatform?.toLowerCase() === "googlemeet" &&
          !data?.eventBooking?.roomId
        ) {
          return 5000;
        }
        return false;
      },
    }
  );
  const tz = momentTimeZone.tz.guess(true);

  if (getCustomerLiveClassBookingQuery.isLoading) {
    return (
      <PublicLayout>
        <div
          style={{
            height: "80vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Spin size="large" />
        </div>
      </PublicLayout>
    );
  }
  if (getCustomerLiveClassBookingQuery.isError) {
    return (
      <PublicLayout>
        <Result
          status="error"
          title="An Error Occurred"
          subTitle={getCustomerLiveClassBookingQuery.error.message}
          extra={[
            <Button
              onClick={() => getCustomerLiveClassBookingQuery.refetch}
              type="default"
              key="console"
              size="small"
            >
              Try again
            </Button>,
          ]}
        />
      </PublicLayout>
    );
  }

  const disableButton = () => {
    return isLiveClassJoinButtonDisabled(getCustomerLiveClassBookingQuery.data);
  };

  const joinMeetingUrl = resolveLiveClassJoinMeetingUrl(
    getCustomerLiveClassBookingQuery.data
  );
  const classDate = moment(
    getCustomerLiveClassBookingQuery.data?.eventBooking.event_date
  ).format("ddd, MMM DD YYYY");
  const displayTimezone = resolveLiveClassJoinDisplayTimezone({
    booking: getCustomerLiveClassBookingQuery.data,
    browserTimezone: tz,
  });
  return (
    <PublicLayout>
      <StyledFlexContainer>
        <Spin
          spinning={getCustomerLiveClassBookingQuery.isFetching}
          indicator={LoadingSpinner}
          tip="Updating..."
        >
          <StyledJoinCallBox>
            <div>
              <Image
                preview={false}
                //   width={"100%"}
                src="/images/join-meeting-image.svg"
                alt="meeting"
              />
            </div>
            <p className="join-meeting-title">
              "{getCustomerLiveClassBookingQuery.data?.event.name}" with{" "}
              {getCustomerLiveClassBookingQuery.data?.coach.firstName}{" "}
              {getCustomerLiveClassBookingQuery.data?.coach.lastName}
            </p>
            <div>
              <Button
                size="small"
                block
                disabled={disableButton()}
                type="primary"
                htmlType="button"
                target="_blank"
                href={disableButton() ? undefined : joinMeetingUrl}
              >
                Join video call now
              </Button>
            </div>
            {getCustomerLiveClassBookingQuery.data.eventBooking.statusName.toLowerCase() ===
            "completed" ? (
              <p>This class has ended</p>
            ) : disableButton() ? (
              <p>
                {getLiveClassJoinDisabledMessage(getCustomerLiveClassBookingQuery.data)}
              </p>
            ) : null}
            <div>
              <StyledJoinCallExtraInfo>
                <div className="call-card-extra-info-item">
                  <Space size={10}>
                    <CalendarOutlined style={{color: "#222222"}} />
                    <span className="call-card-extra-info-item-value">
                      {
                        getCustomerLiveClassBookingQuery.data?.eventBooking
                          .customer_event_time
                      }
                      , {classDate}
                    </span>
                  </Space>
                </div>
                <div className="call-card-extra-info-item">
                  <Space size={10}>
                    <HourglassOutlined style={{color: "#222222"}} />
                    <span className="call-card-extra-info-item-value">
                      {getCustomerLiveClassBookingQuery.data?.eventBooking.call_duration}{" "}
                      minutes
                    </span>
                  </Space>
                </div>
              </StyledJoinCallExtraInfo>
              <StyledJoinCallExtraInfo style={{marginTop: "2.5rem"}}>
                <div className="call-card-extra-info-item">
                  <Space size={10}>
                    <GlobalOutlined style={{color: "#222222"}} />
                    <span className="call-card-extra-info-item-value">
                      {displayTimezone}
                    </span>
                  </Space>
                </div>
                <div className="phone-number-extra-details">
                  <div className="call-card-extra-info-item">
                    <Space size={10}>
                      <>
                        <VideoCameraOutlined style={{color: "#222222"}} />
                        <span className="call-card-extra-info-item-value">
                          Video call
                        </span>
                      </>
                    </Space>
                  </div>
                </div>
              </StyledJoinCallExtraInfo>
            </div>
          </StyledJoinCallBox>
        </Spin>
      </StyledFlexContainer>
    </PublicLayout>
  );
};

export default LiveClassJoinMeetingPage;
